import { supabase } from "../supabase/client";

const COPY_LOOKUP_BATCH_SIZE = 25;

export async function hasExistingCopyRoute(targetTable, company, targetDates, selectedUsers) {
  if (!["reservations", "tentative_reservations"].includes(targetTable)) {
    throw new Error("예약 테이블을 확인할 수 없습니다.");
  }
  for (let dateIndex = 0; dateIndex < targetDates.length; dateIndex += COPY_LOOKUP_BATCH_SIZE) {
    const dateBatch = targetDates.slice(dateIndex, dateIndex + COPY_LOOKUP_BATCH_SIZE);
    for (let userIndex = 0; userIndex < selectedUsers.length; userIndex += COPY_LOOKUP_BATCH_SIZE) {
      const userBatch = selectedUsers.slice(userIndex, userIndex + COPY_LOOKUP_BATCH_SIZE);
      const { data, error } = await supabase
        .from(targetTable)
        .select("id")
        .eq("company", company)
        .in("date", dateBatch)
        .in("user", userBatch)
        .limit(1);
      if (error) throw error;
      if (data?.length) return true;
    }
  }
  return false;
}

export async function createReservationBatch(rows, summaries, targetTable = "reservations") {
  if (!["reservations", "tentative_reservations"].includes(targetTable)) {
    return { error: new Error("Invalid reservation table") };
  }
  try {
    return await supabase.rpc("create_reservation_batch", {
      p_rows: rows,
      p_summaries: targetTable === "reservations" ? summaries : [],
      p_tentative: targetTable === "tentative_reservations",
    });
  } catch (error) {
    return { error };
  }
}
